import { generateId } from '@/util/idGenerator';
import { InKinkCategory } from '../types/kinks';
import { Rating } from '../types/ratings';

export const getDefaultRatings = (): Rating[] => [
    { name: "N/A", color: '--gen-pair(#DFE0E2)' },
    { name: "Want to try", color: '--gen-pair(#AEAFB0)' },
    { name: "Love it", color: '--semantic-pair(#6DB5FE)' },
    { name: "Like it", color: '--semantic-pair(#23FD22)' },
    { name: "OK (indifferent)", color: '--semantic-pair(#FDFD6B)' },
    { name: "Maybe (Soft Limit)", color: '--semantic-pair(#F57900)' },
    { name: "No (Hard Limit)", color: '--semantic-pair(#910000)' },
];

const createKinkCategory = (name: string, subcategories: string[], kinks: string[], defaultRating: string): InKinkCategory => ({
    id: generateId(),
    name,
    subcategories,
    kinks: kinks.map((kinkname) => ({
        id: generateId(),
        name: kinkname,
        ratings: subcategories.reduce((map: Record<string, string>, subcategory: string) => ({ ...map, [subcategory]: defaultRating }), {}),
    })),
});

export const getDefaultKinkContent = (defaultRating: string): InKinkCategory[] => [
    createKinkCategory("Gender interaction", ["Male-presenting",
"Female-presenting",
"Androgynous"
],
    ["One on one",
"Threesomes",
"Orgies"
], defaultRating),
    createKinkCategory("Bodies", ["General"
], 
[
"Big butts",
"Big dicks",
"Big tits",
"Body hair (armpits)",
"Body hair (arms)",
"Body hair (face)",
"Body hair (genitalia)",
"Body hair (legs)",
"Body hair (torso)",
"Hair (long)",
"Hair (none)",
"Hair (short)"
], defaultRating),
    createKinkCategory("Accesories", ["Self",
"Partners"
], 
[
"Piercings (ears)",
"Piercings (face)",
"Piercings (genitalia)",
"Piercings (mouth/tongue)",
"Piercings (nipples)",
"Scarification",
"Tattoos (body)",
"Tattoos (face)",
], defaultRating),
    createKinkCategory("Clothing", ["Self",
"Partners"
], 
[
"Body harnesses (leather)",
"Body harnesses (others)",
"Body harnesses (rope)",
"Boots",
"Boxers/boy shorts",
"Clothed sex",
"Corsets",
"Costumes",
"Crossdressing",
"Drag",
"Dresses (casual)",
"Dresses (formal)",
"High heels",
"Jockstraps",
"Murrsuits",
"No underwear",
"Nudity",
"Panties (crotchless)",
"Panties",
"Posture collar",
"Shirts (casual)",
"Shirts (formal)",
"Shirts (tees)",
"Shoes",
"Skirts (casual)",
"Skirts (formal)",
"Skirts/dresses (very short)",
"Sneakers",
"Stockings",
"Thongs",
"Uniforms (medical)",
"Uniforms (millitary/police)",
"Wigs (fantasy)",
"Wigs (normal)"
], defaultRating),
    createKinkCategory("Materials", ["Touching", "Wearing"], 
[
"Denim",
"Faux fur",
"Faux leather",
"Fur",
"Lace",
"Latex",
"Leather",
"Satin",
"Silk",
"Velvet",
"Vinyl"
], defaultRating),
    createKinkCategory("Butt stuff", ["Giving/Doing", "Receiving"], 
[
"Assjobs",
"Fingering",
"Fisting",
"Penetration (bareback)",
"Penetration (double)",
"Penetration (penis)",
"Penetration (toys)",
"Penetration (toys, vibrating)",
"Prolapse",
"Rimming",
"Teasing",
], defaultRating),
    createKinkCategory("Mouth stuff", ["Giving/Doing", "Receiving/Wearing"], 
[
"Blowjobs",
"Cunnilingus",
"Deepthroating",
"Drooling",
"Feeding (candy)",
"Feeding (chocolate)",
"Feeding (fruit)",
"Feeding (ice cream)",
"Feeding (other)",
"Fingers",
"Gagging",
"Gags (ball)",
"Gags (horsebite)",
"Gags (phallic)",
"Gags (ring)",
"Gags (spider)",
"Kissing (biting)",
"Kissing (normal)",
"Kissing (sloppy)",
"Penetration (double)",
"Penetration (penis)",
"Penetration (toys)"
], defaultRating),
    createKinkCategory("Sex, other", ["Giving/Doing", "Receiving"], 
[
"Breast/Chest Play",
"Docking (breasts)",
"Docking (penis)",
"Double barreling",
"Edging",
"Footjobs",
"Handjobs",
"Nipple Play",
"Scissoring",
"Titjobs"
], defaultRating),
    createKinkCategory("Sex, vaginal", ["Giving/Doing", "Receiving"], 
[
"Fingering",
"Fisting",
"Kissing",
"Penetration (bareback)",
"Penetration (double)",
"Penetration (penis)",
"Penetration (toys)",
"Teasing",
], defaultRating),
    createKinkCategory("Toys", ["Wearing/on self",
"Giving/on partners"
], 
[
"Air-suction",
"Butt plugs",
"Cock rings",
"DIY",
"Fuck machines",
"Insertable toys (glass)",
"Insertable toys (inflatable)",
"Insertable toys (metal)",
"Kegel balls",
"Magic wands",
"Strap-ons (wearing)",
"Vibrators (external)",
"Vibrators (internal)",
], defaultRating),
    createKinkCategory("Aftercare & Non-sexual", ["General"
], 
[
"Candles/aromas",
"Caressing",
"Cuddling",
"Dinner/lunch",
"Massages",
"Ointments/creams",
"Sleeping/napping",
"Snacks",
"Spooning",
"Talking (discussion)",
"Talking (reassurance)",
"Vanilla Sex",
"Watching TV",
], defaultRating),
    createKinkCategory("Cruising", ["General"
], [
"Anonymous sex",
"Dark rooms",
"Dogging",
"Exhibitionism",
"Gloryholes",
"Sex clubs",
"Under-stall",
"Voyeurism"
], defaultRating),
    createKinkCategory("Body Worship", ["Giving",
"Receiving"
], 
[
"Ass worship",
"Breast worship",
"Cock worship",
"Foot worship",
"Pussy worship"
], defaultRating),
    createKinkCategory("Domination", ["Top",
"bottom"
], 
[
"Begging",
"Brat play",
"Crawling",
"Discipline",
"Domestic servitude",
"Eye-contact restriction",
"Facesitting",
"Forced orgasm",
"Full-time power exchange",
"Kneeling",
"Learned positions",
"Orders",
"Pain training",
"Pet play",
"Ruined orgasm",
"Slavery",
"Speaking restriction",
"Washroom restriction"
], defaultRating),
    createKinkCategory("Public play", ["Top/giving",
"bottom/receiving"
], 
[
"Begging",
"Brat play",
"Discipline",
"Eye-contact restriction",
"Forced orgasm",
"Kneeling",
"Learned positions",
"Masturbation (hands)",
"Orders",
"Speaking restriction",
"Toys (buttplug)",
"Toys (remote masturbation)",
"Washroom restriction"
], defaultRating),
    createKinkCategory("Restrictive", ["Giving/On partners",
"Receiving/On me"
], 
[
"Bondage (chains)",
"Bondage (ropes)",
"Bondage (shibari)",
"Bondage (zip ties)",
"Cages",
"Chastity",
"Collar and leash",
"Restraints (arms behind back)",
"Restraints (arms in front)",
"Restraints (hands)",
"Restraints (hogtie)",
"Restraints (legs)",
"Restraints (mummification)",
"Restraints (spreaders)",
"Suspension (chains)",
"Suspension (hooks)",
"Suspension (rope)",
], defaultRating),
    createKinkCategory("Impact Play", ["Inflicting",
"Receiving"
], 
[
"Bastinado",
"Belt (buckle)",
"Belt (strap)",
"Caning (glass)",
"Caning (metal)",
"Caning (plastic/polymers)",
"Caning (wood)",
"Cock torture",
"Flogging",
"Kicking",
"Paddling",
"Punching",
"Pussy torture",
"Slapping (breasts)",
"Slapping (face)",
"Spanking",
"Strapping (leather)",
"Strapping (other)",
"Strapping (rubber)",
"Whipping"
], defaultRating),
    createKinkCategory("Markings", ["On me",
"On partners"
], 
[
"Bite marks",
"Branding (fire)",
"Branding (ice)",
"Bruising (heavy)",
"Bruising (light)",
"Finger marks",
"Hickies",
"Scars",
"Writing (on body)",
"Writing (on face)",
], defaultRating),
    createKinkCategory("Degradation", ["Inflicting/Top",
"receiving/bottom"
], 
[
"Bimboification",
"Body Shaming (general)",
"Body Shaming (genitals)",
"Cuckold / cuckquean",
"Forced feminization",
"Forced masculinization",
"Forced shaving (body)",
"Forced shaving (genitals)",
"Forced shaving (head)",
"Forniphilia",
"Gangbangs",
"Verbal (good boy/girl)",
"Verbal (gender/orientation)",
"Verbal (name calling)",
"Verbal (other insults)",
"Verbal (racial)",
"Verbal (slut shaming)",
], defaultRating),
    createKinkCategory("Substances (during play)", ["Me",
"Partners"
], 
[
"Acid",
"Alcohol",
"Drugs (legal)",
"Drugs (other)",
"MDMA",
"Poppers",
"Tobacco",
"Weed",
], defaultRating),
    createKinkCategory("Consensual Nonconsent", ["Aggressor",
"victim"
], 
[
"Blackmail / coercion",
"Forced substances (alcohol)",
"Forced substances (legal drugs)",
"Forced substances (other drugs)",
"Forced substances (tobacco)",
"Free use (friends)",
"Free use (partners)",
"Free use (strangers)",
"Kidnapping",
"Rape play",
"Sleeping sex (unconscious)",
"Sleeping sex (waking up)",
], defaultRating),
    createKinkCategory("Sensations", ["Giving/Top",
"Receiving/bottom"
], 
[
"Blades (cutting)",
"Blades (playing)",
"Clothespins (body)",
"Clothespins (nipples)",
"Electrical(cattle prod)",
"Electrical(TENS Unit)",
"Electrical(Violet wand)",
"Feathers",
"Figging",
"Fire play",
"Hair stroking",
"Head petting",
"Hot wax",
"Ice play",
"Long nails",
"Nipple clamps",
"Temperature play",
"Tickling",
"Vampire gloves",
"Wartenberg wheel"
], defaultRating),
    createKinkCategory("Sensory Deprivation", ["Giving/Top",
"Receiving/bottom"
], 
[
"Blindfolds",
"Earplugss",
"Full-head Hoods"
], defaultRating),
    createKinkCategory("Medical", ["Giving/Top",
"Receiving/bottom"
], 
[
"Dilation",
"Needle play",
"Urethral sounding",
"Speculum",
"Sutures"
], defaultRating),
    createKinkCategory("Primal", ["Predator",
"prey"
], 
[
"Biting",
"Breath Play (Choking)",
"Crying",
"Growling",
"Hair Pulling",
"Howling",
"Ripping/tearing clothes",
"Ripping/tearing underwear",
"Scratching",
"Screaming",
"Wrestling"
], defaultRating),
    createKinkCategory("Roleplay", ["General"
], 
[
"Ageplay (ABDL)",
"Ageplay (other)",
"Caregiver / little",
"Cheating",
"Furries",
"Incest",
"Servitude",
"Teacher/student",
], defaultRating),
    createKinkCategory("Fluids", ["Giving fluid",
"Receiving fluid"
], 
[
"Blood (mine, drinking)",
"Blood (mine, on body)",
"Blood (mine, on face)",
"Blood (partner's, drinking)",
"Blood (partner's, on body)",
"Blood (partner's, on face)",
"Cum (creampie)",
"Cum (creampie eating)",
"Cum (facials)",
"Cum (in mouth)",
"Cum (kissing)",
"Cum (on body)",
"Cum (other)",
"Lactation (drinking)",
"Lactation (on body)",
"Menstruation (licking)",
"Menstruation",
"Pee (forced, clothed)",
"Pee (forced, underwear)",
"Pee (in mouth)",
"Pee (on body)",
"Pee (on face)",
"Pee (other)",
"Scat (eating)",
"Scat (forced, clothed)",
"Scat (forced, underwear)",
"Scat (on body)",
"Scat (on face)",
"Scat (other)",
"Spit (in mouth)",
"Spit (on body)",
"Spit (on face)",
"Squirt (in mouth)",
"Squirt (on body)",
"Squirt (on face)",
"Vaginal fluids (in mouth)",
"Vaginal fluids (on body)",
"Vaginal fluids (on face)",
"Vomit (eating)",
"Vomit (on body)",
"Vomit (on face)",
"Vomit (other)",
], defaultRating),
    createKinkCategory("Control", ["Top/Inflicting",
"bottom/receiving"
], 
[
"Forced attire",
"Forced eating",
"Forced exercise",
"Forced masturbation",
"Forced nudity",
"Forced sexual orientation",
"Impregnation",
], defaultRating),
    createKinkCategory("Sharing media", ["Sharing",
"Receiving"
], 
[
"Ass (photos/videos)",
"Body (clothed)",
"Body (unclothed)",
"Detailed stories (audio)",
"Detailed stories (written)",
"Face (photos/videos)",
"Fantasy stories (audio)",
"Fantasy stories (written)",
"Feet (photos/videos)",
"Genitalia (covered)",
"Genitalia (uncovered)",
"Humiliating poses (photos/videos)",
"Kinky sex (photos/videos)",
"Real stories (audio)",
"Real stories (written)",
"Sexual audio (bodily noises)",
"Sexual audio (moaning)",
"Sexual audio (stories)",
"Vanilla sex (photos/videos)",
], defaultRating),
]
